/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Priority_HighInputs */

const en_priority_high = /** @type {(inputs: Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High`)
};

const de_priority_high = /** @type {(inputs: Priority_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoch`)
};

/**
* | output |
* | --- |
* | "High" |
*
* @param {Priority_HighInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const priority_high = /** @type {((inputs?: Priority_HighInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Priority_HighInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_priority_high(inputs)
	return en_priority_high(inputs)
});